import auth from "./auth/reducer";

// Combine all reducers.
export default {
  auth
};
